import React from 'react';
import { formatDateWithTime, numberWithCommas, getInfluenceName} from 'utils/other';
import { Button } from 'reactstrap'
import './style.scss';

function NewsItem(props) {    
    return (
        <div className="news_item-container">
            {props.selectedNewsItem && 
                <React.Fragment>
                    <div className="news_item-title">
                        {props.selectedNewsItem.title}
                    </div>
                    <div style={{ fontSize: '1.1rem', margin: '5px 0' }}>
                        <span>
                            {`${props.selectedNewsItem.domain} 
                                ${props.selectedNewsItem.publishedAt ? 
                                    ' • ' + formatDateWithTime(props.selectedNewsItem.publishedAt) 
                                : 
                                    ''
                                }
                            `}
                        </span>
                        {props.selectedNewsItem.authorScreenName && (
                            <a 
                                target="_blank"
                                rel="noopener noreferrer"
                                href={props.selectedNewsItem.authorUrl} 
                                style={{ textDecoration: 'underline', paddingLeft: '5px' }}
                            >
                                {props.selectedNewsItem.authorScreenName}
                            </a>
                        )}
                        {props.selectedNewsItem.influence && (
                            <span>
                                &nbsp;{`(${numberWithCommas(props.selectedNewsItem.influence)} ${getInfluenceName(props.sourceType)})`}
                            </span>
                        )}
                    </div>
                    <div style={{ fontSize: '1.3rem', margin: '5px 0', textAlign: 'justify' }}>
                        {props.selectedNewsItem.abstract ? props.selectedNewsItem.abstract : ''}
                    </div>
                    <div className="w-100 d-flex justify-content-end">
                        <Button 
                            href={props.selectedNewsItem.url}
                            rel="noopener"
                            target="_blank"
                            style={{ color: 'white', minWidth: '110px', margin: '15px 0' }} 
                            className="btn typical-button target_input-btn"
                        >
                            Read More
                        </Button>
                    </div>
                </React.Fragment>
            }
        </div>
    );
}

export default NewsItem;